<div class="navbar-area navbar-style-two is-sticky" id="top">
  <div class="plor-responsive-nav">
    <div class="container-fluid">
      <div class="plor-responsive-menu">
        <div class="logo">
          <a [routerLink]="'home' | route" class="d-flex align-items-center">
            <img width="170" height="32" src="/assets/img/logo.svg" alt="dotcrea logo">
            <svg class="mx-1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
              <path fill="#6c757d"
                d="m6.4 18.308l-.708-.708l5.6-5.6l-5.6-5.6l.708-.708l5.6 5.6l5.6-5.6l.708.708l-5.6 5.6l5.6 5.6l-.708.708l-5.6-5.6z" />
            </svg>
            <img src="assets/img/shpp.svg" alt="Shopify Partner">
          </a>
        </div>
        <div class="mobile-menu" (click)="toggleMobileMenu()">
          <i class="flaticon-menu"></i>
        </div>
        <!-- Mobil Menü -->
        <div class="mobile-menu-container" [class.active]="mobileMenuOpen">
          <div class="mobile-menu-overlay" (click)="toggleMobileMenu()"></div>
          <div class="mobile-menu-inner">
            <div class="mobile-menu-header">
              <div class="logo">
                <img width="140" src="/assets/img/logo.svg" alt="dotcrea logo">
              </div>
              <div class="close-btn" (click)="toggleMobileMenu()">
                <i class='bx bx-x'></i>
              </div>
            </div>
            <div class="mobile-menu-body">
              <ul class="mobile-nav-list">
                <li class="nav-item">
                  <a class="nav-link" (click)="toggleDropdown('shopify')">
                    {{'text_shopify'|translate}}
                    <i class='bx bx-chevron-down' [class.rotate]="activeDropdown === 'shopify'"></i>
                  </a>
                  <ul class="mobile-dropdown" [class.show]="activeDropdown === 'shopify'">
                    <li class="dropdown-section">
                      <ul class="dropdown-items">
                        <li><a [routerLink]="'shopify_store_setup' | route" (click)="closeMenu()">Mağaza Kurulumu</a>
                        </li>
                        <li><a [routerLink]="'shopify_migration' | route" (click)="closeMenu()">Shopify'a Geçiş</a></li>
                        <li><a [routerLink]="'shopify_theme_development' | route" (click)="closeMenu()">Tema
                            Geliştirme</a></li>
                        <li><a [routerLink]="'shopify_theme_customization' | route" (click)="closeMenu()">Tema
                            Özelleştirme</a></li>
                        <li><a [routerLink]="'shopify_app_development' | route" (click)="closeMenu()">Uygulama
                            Geliştirme</a></li>
                        <li><a [routerLink]="'shopify_maintenance' | route" (click)="closeMenu()">Bakım ve Destek</a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li class="nav-item">
                  <a class="nav-link" (click)="toggleDropdown('integrations')">
                    {{'text_menu_integrations'|translate}}
                    <i class='bx bx-chevron-down' [class.rotate]="activeDropdown === 'integrations'"></i>
                  </a>
                  <ul class="mobile-dropdown" [class.show]="activeDropdown === 'integrations'">
                    <li class="dropdown-section">
                      <div class="dropdown-header">{{'text_marketplace'|translate}}</div>
                      <ul class="dropdown-items">
                        <li><a [routerLink]="'trendyol_integration' | route" (click)="closeMenu()">Trendyol</a></li>
                        <li><a [routerLink]="'hepsiburada_integration' | route" (click)="closeMenu()">Hepsiburada</a>
                        </li>
                        <li><a [routerLink]="'n11_integration' | route" (click)="closeMenu()">N11</a></li>
                        <li><a [routerLink]="'amazon_integration' | route" (click)="closeMenu()">Amazon</a></li>
                        <li><a [routerLink]="'ciceksepeti_integration' | route" (click)="closeMenu()">Çiçeksepeti</a>
                        </li>
                        <li><a [routerLink]="'pttavm_integration' | route" (click)="closeMenu()">PttAvm</a></li>
                        <li><a [routerLink]="'akakce_integration' | route" (click)="closeMenu()">Akakçe</a></li>
                      </ul>
                    </li>

                    <li class="dropdown-section">
                      <div class="dropdown-header">{{ 'text_ecommerce' | translate }}</div>
                      <ul class="dropdown-items">
                        <li><a [routerLink]="'shopify_integration' | route" (click)="closeMenu()">Shopify</a></li>
                        <li><a [routerLink]="'woocommerce_integration' | route" (click)="closeMenu()">WooCommerce</a>
                        </li>
                        <li><a [routerLink]="'opencart_integration' | route" (click)="closeMenu()">OpenCart</a></li>
                        <li><a [routerLink]="'rgsyazilim_integration' | route" (click)="closeMenu()">RGS</a></li>
                      </ul>
                    </li>

                    <li class="dropdown-section">
                      <div class="dropdown-header">{{ 'text_accounting' | translate }}</div>
                      <ul class="dropdown-items">
                        <li><a [routerLink]="'parasut_integration' | route" (click)="closeMenu()">Paraşüt</a></li>
                        <li><a [routerLink]="'bizimhesap_integration' | route" (click)="closeMenu()">BizimHesap</a></li>
                        <li><a [routerLink]="'dia_integration' | route" (click)="closeMenu()">Dia</a></li>
                        <li><a [routerLink]="'uyumsoft_integration' | route" (click)="closeMenu()">Uyumsoft</a></li>
                        <li><a [routerLink]="'edm_integration' | route" (click)="closeMenu()">EDM</a></li>
                      </ul>
                    </li>

                    <li class="dropdown-section">
                      <div class="dropdown-header">{{ 'text_cargo' | translate }}</div>
                      <ul class="dropdown-items">
                        <li><a [routerLink]="'aras_cargo' | route" (click)="closeMenu()">Aras Kargo</a></li>
                        <li><a [routerLink]="'yurtici_cargo' | route" (click)="closeMenu()">Yurtiçi Kargo</a></li>
                        <li><a [routerLink]="'mng_cargo' | route" (click)="closeMenu()">MNG Kargo</a></li>
                        <li><a [routerLink]="'ptt_cargo' | route" (click)="closeMenu()">PTT Kargo</a></li>
                      </ul>
                    </li>

                    <li class="dropdown-section">
                      <div class="dropdown-header">Ödeme</div>
                      <ul class="dropdown-items">
                        <li><a [routerLink]="'paytr_integration' | route" (click)="closeMenu()">PayTR</a></li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li class="nav-item">
                  <a class="nav-link" (click)="toggleDropdown('pricing')">
                    Fiyatlandırma
                    <i class='bx bx-chevron-down' [class.rotate]="activeDropdown === 'pricing'"></i>
                  </a>
                  <ul class="mobile-dropdown" [class.show]="activeDropdown === 'pricing'">
                    <li class="dropdown-section">
                      <ul class="dropdown-items">
                        <li><a [routerLink]="'pricing' | route" (click)="closeMenu()">Shopify Hizmetleri</a></li>
                        <li><a [routerLink]="'integration_pricing' | route" (click)="closeMenu()">Entegrasyon
                            Paketleri</a></li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li class="nav-item">
                  <a [routerLink]="'contact' | route" class="nav-link"
                    (click)="closeMenu()">{{'text_menu_contact'|translate}}</a>
                </li>
              </ul>

              <div class="mobile-menu-footer mt-4">
                <a [routerLink]="'contact' | route" (click)="closeMenu()" class="btn btn-primary w-100">İletişime
                  Geçin</a>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="plor-nav">
    <div class="container">
      <nav class="navbar navbar-expand-md navbar-light">
        <a class="navbar-brand d-flex align-items-center" [routerLink]="'home' | route">
          <img width="240" height="44" src="/assets/img/logo.svg" alt="dotcrea logo">
          <svg class="mx-1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
            <path fill="#6c757d"
              d="m6.4 18.308l-.708-.708l5.6-5.6l-5.6-5.6l.708-.708l5.6 5.6l5.6-5.6l.708.708l-5.6 5.6l5.6 5.6l-.708.708l-5.6-5.6z" />
          </svg>
          <img src="assets/img/shpp.svg" alt="Shopify Partner" style="height: 30px;">
        </a>
        <div class="collapse navbar-collapse">
          <ul class="navbar-nav me-5 ms-auto">
            <li class="nav-item">
              <span class="nav-link">{{'text_shopify'|translate}}
                <i class='bx bx-chevron-down'></i>
              </span>
              <ul class="dropdown-menu">
                <li class="nav-item">
                  <a [routerLink]="'shopify_store_setup' | route" class="nav-link">Mağaza Kurulumu</a>
                </li>
                <li class="nav-item">
                  <a [routerLink]="'shopify_migration' | route" class="nav-link">Shopify'a Geçiş(Migrate)</a>
                </li>
                <li class="nav-item">
                  <a [routerLink]="'shopify_theme_development' | route" class="nav-link">Shopify Tema Geliştirme</a>
                </li>
                <li class="nav-item">
                  <a [routerLink]="'shopify_theme_customization' | route" class="nav-link">Shopify Tema Özelliştirme</a>
                </li>
                <li class="nav-item">
                  <a [routerLink]="'shopify_app_development' | route" class="nav-link">Shopify Uygulama Geliştirme</a>
                </li>
                <li class="nav-item">
                  <a [routerLink]="'shopify_maintenance' | route" class="nav-link">Bakım ve Destek</a>
                </li>
              </ul>
            </li>
            <li class="nav-item megamenu">
              <span class="nav-link">{{'text_menu_integrations'|translate}}
                <i class='bx bx-chevron-down'></i>
              </span>
              <ul class="dropdown-menu">
                <li class="nav-item">
                  <span>{{'text_marketplace'|translate}}</span>
                  <a [routerLink]="'trendyol_integration' | route" class="nav-link" routerLinkActive="active"
                    title="{{'text_marketplace_solutions'| translate}}" [routerLinkActiveOptions]="{exact: true}">
                    <img width="44" height="44" src="/assets/img/svg/trendyol.svg" alt="Trendyol Entegrasyonu"
                      title="Trendyol Entegrasyonu - Türkiye'nin en büyük online pazar yeri" /> Trendyol </a>
                  <a [routerLink]="'hepsiburada_integration' | route" class="nav-link" routerLinkActive="active"
                    title="{{'text_marketplace_solutions'| translate}}" [routerLinkActiveOptions]="{exact: true}">
                    <img width="44" height="44" src="/assets/img/svg/hepsiburada.svg" alt="Hepsiburada Entegrasyonu"
                      title="Hepsiburada Entegrasyonu - Türkiye'nin öncü e-ticaret platformu" /> Hepsiburada </a>
                  <a [routerLink]="'n11_integration' | route" class="nav-link" routerLinkActive="active"
                    title="{{'text_marketplace_solutions'| translate}}" [routerLinkActiveOptions]="{exact: true}">
                    <img width="44" height="44" src="/assets/img/svg/n11.svg" alt="N11 Entegrasyonu"
                      title="N11 Entegrasyonu - Geniş ürün yelpazesi sunan pazar yeri" /> N11 </a>
                  <a [routerLink]="'ciceksepeti_integration' | route" class="nav-link" routerLinkActive="active"
                    title="{{'text_marketplace_solutions'| translate}}" [routerLinkActiveOptions]="{exact: true}">
                    <img width="44" height="44" src="/assets/img/svg/ciceksepeti.svg" alt="Çiçeksepeti Entegrasyonu"
                      title="Çiçeksepeti Entegrasyonu - Çiçek ve hediye alışverişi için popüler site" /> Çiçeksepeti
                  </a>
                  <a [routerLink]="'pttavm_integration' | route" routerLinkActive="active"
                    title="{{'text_marketplace_solutions'| translate}}" [routerLinkActiveOptions]="{exact: true}">
                    <img width="44" height="44" src="/assets/img/svg/pttavm.svg" alt="PttAvm Entegrasyonu"
                      title="PttAvm Entegrasyonu - Güvenilir online alışveriş platformu" /> PttAvm </a>
                  <a [routerLink]="'akakce_integration' | route" routerLinkActive="active"
                    title="{{'text_marketplace_solutions'| translate}}" [routerLinkActiveOptions]="{exact: true}">
                    <img width="44" height="44" src="/assets/img/svg/akakce.svg" alt="Akakçe Entegrasyonu"
                      title="Akakçe Entegrasyonu - Fiyat karşılaştırma ve alışveriş" /> Akakçe </a>
                  <a [routerLink]="'amazon_integration' | route" routerLinkActive="active"
                    title="{{'text_marketplace_solutions'| translate}}" [routerLinkActiveOptions]="{exact: true}">
                    <img width="44" height="44" src="/assets/img/svg/amazon.svg" alt="Amazon Entegrasyonu"
                      title="Amazon Entegrasyonu - Küresel e-ticaret devinin platformu" /> Amazon </a>
                </li>
                <li class="nav-item">
                  <span>{{ 'text_ecommerce' | translate }}</span>
                  <a [routerLink]="'shopify_integration' | route" class="nav-link" routerLinkActive="active"
                    [routerLinkActiveOptions]="{exact: true}">
                    <img width="44" height="44" src="/assets/img/svg/shopify.svg" alt="Shopify Entegrasyonu"
                      title="Shopify E-ticaret Entegrasyonu" /> Shopify </a>
                  <a [routerLink]="'rgsyazilim_integration' | route" class="nav-link" routerLinkActive="active"
                    title="{{'text_marketplace_solutions'| translate}}" [routerLinkActiveOptions]="{exact: true}">
                    <img width="44" height="44" src="/assets/img/svg/rgs.svg" alt="RGS Entegrasyonu"
                      title="RGS E-ticaret Entegrasyonu" /> RGS </a>

                  <a [routerLink]="'opencart_integration' | route" class="nav-link" routerLinkActive="active"
                    [routerLinkActiveOptions]="{exact: true}">
                    <img width="44" height="44" src="/assets/img/svg/opencart.svg" alt="Opencart Entegrasyonu"
                      title="Opencart E-ticaret Entegrasyonu" /> Opencart </a>
                  <a [routerLink]="'woocommerce_integration' | route" class="nav-link" routerLinkActive="active"
                    [routerLinkActiveOptions]="{exact: true}">
                    <img width="44" height="44" src="/assets/img/svg/woocommerce.svg" alt="Woocommerce Entegrasyonu"
                      title="Woocommerce E-ticaret Entegrasyonu" /> Woocommerce </a>


                </li>
                <li class="nav-item">
                  <span>{{ 'text_accounting' | translate }}</span>
                  <a [routerLink]="'parasut_integration' | route" class="nav-link" routerLinkActive="active"
                    [routerLinkActiveOptions]="{exact: true}">
                    <img width="44" height="44" src="/assets/img/svg/parasut.svg" alt="Paraşüt Muhasebe Entegrasyonu"
                      title="Paraşüt Entegrasyonu" /> Paraşüt </a>
                  <a [routerLink]="'bizimhesap_integration' | route" class="nav-link" routerLinkActive="active"
                    [routerLinkActiveOptions]="{exact: true}">
                    <img width="44" height="44" src="/assets/img/svg/bizimhesap.svg"
                      alt="BizimHesap Muhasebe Entegrasyonu" title="BizimHesap Entegrasyonu" /> BizimHesap </a>
                  <a [routerLink]="'dia_integration' | route" class="nav-link" routerLinkActive="active"
                    [routerLinkActiveOptions]="{exact: true}">
                    <img width="44" height="44" src="/assets/img/svg/dia.svg" alt="Dia Muhasebe Entegrasyonu"
                      title="Dia Entegrasyonu" /> Dia Muhasebe </a>
                  <a [routerLink]="'uyumsoft_integration' | route" class="nav-link" routerLinkActive="active"
                    [routerLinkActiveOptions]="{exact: true}">
                    <img width="44" height="44" src="/assets/img/svg/uyumsoft.svg" alt="Uyumsoft Muhasebe Entegrasyonu"
                      title="Uyumsoft Entegrasyonu" /> Uyumsoft </a>
                  <a [routerLink]="'edm_integration' | route" class="nav-link" routerLinkActive="active"
                    [routerLinkActiveOptions]="{exact: true}">
                    <img width="44" height="44" src="/assets/img/svg/edm.svg" alt="EDM Muhasebe Entegrasyonu"
                      title="EDM Entegrasyonu" /> EDM </a>
                  <hr>

                  <span>Ödeme</span>
                  <a [routerLink]="'paytr_integration' | route" class="nav-link" routerLinkActive="active"
                    [routerLinkActiveOptions]="{exact: true}">
                    <img width="44" height="44" src="/assets/img/svg/paytr.svg" alt="PayTR Entegrasyonu"
                      title="PayTR Entegrasyonu" /> PayTR </a>


                </li>
                <li class="nav-item">
                  <span>{{ 'text_cargo' | translate }}</span>
                  <a [routerLink]="'aras_cargo' | route" class="nav-link" routerLinkActive="active"
                    [routerLinkActiveOptions]="{exact: true}">
                    <img width="44" height="44" src="/assets/img/svg/araskargo.svg" alt="Aras Kargo Hizmeti"
                      title="Aras Kargo Entegrasyonu" /> Aras Kargo </a>
                  <a [routerLink]="'yurtici_cargo' | route" class="nav-link" routerLinkActive="active"
                    [routerLinkActiveOptions]="{exact: true}">
                    <img width="44" height="44" src="/assets/img/svg/yurticikargo.svg" alt="Yurtiçi Kargo Hizmeti"
                      title="Yurtiçi Kargo Entegrasyonu" /> Yurtiçi Kargo </a>
                  <a [routerLink]="'mng_cargo' | route" class="nav-link" routerLinkActive="active"
                    [routerLinkActiveOptions]="{exact: true}">
                    <img width="44" height="44" src="/assets/img/svg/mngkargo.svg" alt="MNG Kargo Hizmeti"
                      title="MNG Kargo Entegrasyonu" /> MNG Kargo </a>
                  <a [routerLink]="'surat_cargo' | route" class="nav-link" routerLinkActive="active"
                    [routerLinkActiveOptions]="{exact: true}">
                    <img width="44" height="44" src="/assets/img/svg/suratkargo.svg" alt="Sürat Kargo Hizmeti"
                      title="Sürat Kargo Entegrasyonu" /> Sürat Kargo </a>
                  <a [routerLink]="'ptt_cargo' | route" class="nav-link" routerLinkActive="active"
                    [routerLinkActiveOptions]="{exact: true}">
                    <img width="44" height="44" src="/assets/img/svg/ptt_kargo.svg" alt="PTT Kargo Hizmeti"
                      title="PTT Kargo Entegrasyonu" /> PTT Kargo </a>
                  <a [routerLink]="'ups_cargo' | route" class="nav-link" routerLinkActive="active"
                    [routerLinkActiveOptions]="{exact: true}">
                    <img width="44" height="44" src="/assets/img/svg/ups.svg" alt="UPS Kargo Hizmeti"
                      title="UPS Kargo Entegrasyonu" /> UPS Kargo </a>
                  <a [routerLink]="'hepsijet_cargo' | route" class="nav-link" routerLinkActive="active"
                    [routerLinkActiveOptions]="{exact: true}">
                    <img width="44" height="44" src="/assets/img/svg/hepsijet.svg" alt="Hepsijet Kargo Hizmeti"
                      title="Hepsijet Kargo Entegrasyonu" /> Hepsijet Kargo </a>
                  <a [routerLink]="'sendeo_cargo' | route" class="nav-link" routerLinkActive="active"
                    [routerLinkActiveOptions]="{exact: true}">
                    <img width="44" height="44" src="/assets/img/svg/sendeo.svg" alt="Sendeo Kargo Hizmeti"
                      title="Sendeo Kargo Entegrasyonu" /> Sendeo Kargo </a>
                </li>

                <li class="nav-item _last align-items-center d-flex">
                  <div class="w-100">
                    <span>Entegrasyon paketlerini karşılaştırın</span>
                    <a [routerLink]="'integration_pricing' | route" class="btn btn-warning w-100 mb-2">Fiyatlar</a>
                    <a href="https://panel.entegi.com/account/register?ref=798BI" target="_blank"
                      rel="noopener noreferrer" class="btn btn-success w-100">Ücretsiz Deneyin</a>
                  </div>


                </li>

              </ul>
            </li>

            <li class="nav-item">
              <span class="nav-link">Fiyatlandırma
                <i class='bx bx-chevron-down'></i>
              </span>
              <ul class="dropdown-menu">
                <li class="nav-item">
                  <a [routerLink]="'pricing' | route" class="nav-link">Shopify Hizmetleri</a>
                </li>
                <li class="nav-item">
                  <a [routerLink]="'integration_pricing' | route" class="nav-link">Entegrasyon Paketleri</a>
                </li>
              </ul>
            </li>


          </ul>
          <div class="others-option d-flex align-items-center">
            <div class="start_link">
              <a [routerLink]="'contact' | route" class="btn btn-dark">{{'text_menu_contact'|translate}}</a>
            </div>
          </div>
        </div>
      </nav>
    </div>
  </div>
</div>